export function syncAffiliationData () {
  let target = document.getElementById('canpan-sync');

  if (!!target) {
    target.addEventListener('click', function(event) {
      // canpan_idを取得
      let canpanId = document.querySelector('input[name$="[canpan_id]"]');
      // 数字の正規表現
      const numberRegex = new RegExp(/^[0-9]+$/);
      const message = 'CANPANからデータを取得します。\nよろしいですか？';

      if (!numberRegex.test(canpanId.value)) {
        alert('CANPAN IDを正しく入力してください。');
        return false;
      }

      if (!window.confirm(message)) {
        return false;
      }
      // pathを取得
      let path = target.dataset.path;
      // URLを生成
      let url = new URL(path);
      url.searchParams.set('canpan_id', canpanId.value);
      // URLをPUTで叩く
      let xmlHttpRequest = new XMLHttpRequest();
      xmlHttpRequest.open('GET', url)
      xmlHttpRequest.send();

      // レスポンスを受け取る
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4) {
          if (xmlHttpRequest.status === 200) {
            let data = JSON.parse(xmlHttpRequest.responseText);

            if (!!data['visibility']) {
              let target = document.querySelector('select[name$="[visibility]"]');
              if (!!target) {
                target.value = data['visibility']
              }
            }
            if (!!data['name']) {
              let target = document.querySelector('input[name$="[name]"]');
              if (!!target) {
                target.value = data['name']
              }
            }
            if (!!data['name_reading']) {
              let target = document.querySelector('input[name$="[name_reading]"]');
              if (!!target) {
                target.value = data['name_reading']
              }
            }
            if (!!data['representative_official_position']) {
              let target = document.querySelector('input[name$="[representative_official_position]"]');
              if (!!target) {
                target.value = data['representative_official_position']
              }
            }
            if (!!data['representative_name']) {
              let target = document.querySelector('input[name$="[representative_name]"]');
              if (!!target) {
                target.value = data['representative_name']
              }
            }
            if (!!data['representative_name_reading']) {
              let target = document.querySelector('input[name$="[representative_name_reading]"]');
              if (!!target) {
                target.value = data['representative_name_reading']
              }
            }
            if (!!data['zip_code']) {
              let target = document.querySelector('input[name$="[zip_code]"]');
              if (!!target) {
                target.value = data['zip_code']
              }
            }
            if (!!data['address']) {
              let target = document.querySelector('input[name$="[address]"]');
              if (!!target) {
                target.value = data['address']
              }
            }
            if (!!data['telephone']) {
              let target = document.querySelector('input[name$="[telephone]"]');
              if (!!target) {
                target.value = data['telephone']
              }
            }
            if (!!data['fax']) {
              let target = document.querySelector('input[name$="[fax]"]');
              if (!!target) {
                target.value = data['fax']
              }
            }
            if (!!data['hp_url']) {
              let target = document.querySelector('input[name$="[hp_url]"]');
              if (!!target) {
                target.value = data['hp_url']
              }
            }
            if (!!data['email']) {
              let target = document.querySelector('input[name$="[email]"]');
              if (!!target) {
                target.value = data['email']
              }
            }
            if (!!data['establishment_at'] && data['establishment_at'].length == 8) {
              let year_element = document.querySelector('select[name$="[establishment_at][year]"]');
              if (!!year_element) {
                year_element.value = data['establishment_at'].slice(0,4);
              }
              let month_element = document.querySelector('select[name$="[establishment_at][month]"]');
              if (!!month_element) {
                month_element.value = data['establishment_at'].slice(4,6);
              }
              let day_element = document.querySelector('select[name$="[establishment_at][day]"]');
              if (!!day_element) {
                day_element.value = data['establishment_at'].slice(6,8);
              }
            }
            if (!!data['group_count']) {
              let target = document.querySelector('input[name$="[group_count]"]');
              if (!!target) {
                target.value = data['group_count']
              }
            }
            if (!!data['activity_content']) {
              let target = document.querySelector('textarea[name$="[activity_content]"]');
              if (!!target) {
                target.value = data['activity_content']
              }
            }
            if (!!data['activity_business']) {
              let target = document.querySelector('textarea[name$="[activity_business]"]');
              if (!!target) {
                target.value = data['activity_business']
              }
            }
            if (!!data['put_power']) {
              let target = document.querySelector('textarea[name$="[put_power]"]');
              if (!!target) {
                target.value = data['put_power']
              }
            }
            if (!!data['activity_vision']) {
              let target = document.querySelector('textarea[name$="[activity_vision]"]');
              if (!!target) {
                target.value = data['activity_vision']
              }
            }
            if (!!data['purpose']) {
              let target = document.querySelector('textarea[name$="[purpose]"]');
              if (!!target) {
                target.value = data['purpose']
              }
            }
            if (!!data['registry_at']) {
              let target = document.querySelector('textarea[name$="[registry_at]"]');
              if (!!target) {
                target.value = data['registry_at']
              }
            }
            if (!!data['main_place']) {
              let target = document.querySelector('textarea[name$="[main_place]"]');
              if (!!target) {
                target.value = data['main_place']
              }
            }
            if (!!data['message']) {
              let target = document.querySelector('textarea[name$="[message]"]');
              if (!!target) {
                target.value = data['message']
              }
            }
            if (!!data['publish_info_level']) {
              let target = document.querySelector('textarea[name$="[publish_info_level]"]');
              if (!!target) {
                target.value = data['publish_info_level']
              }
            }
            if (!!data['third_party_certificated']) {
              let target = document.querySelector('textarea[name$="[catedthird_party_certificated]"]');
             if (!!target) {
                target.value = data['third_party_certificated']
              }
            }
            if (!!Object.keys(data['activity_fields_attributes']).length) {
              let activity_fields = data['activity_fields_attributes'];

              for (let key in activity_fields) {
                let target = document.querySelector('input[id$="field_ids_' + key + '"]')
                if (!!target) {
                  target.checked = true;
                }
              }
            }
            if (!!data['url1']) {
              let target = document.querySelector('input[name$="[group_url1]"]');
              if (!!target) {
                target.value = data['url1']
              }
            }
            if (!!data['url2']) {
              let target = document.querySelector('input[name$="[group_url2]"]');
              if (!!target) {
                target.value = data['url2']
              }
            }
            if (!!data['url3']) {
              let target = document.querySelector('input[name$="[group_url3]"]');
              if (!!target) {
                target.value = data['url3']
              }
            }
            if (!!data['url4']) {
              let target = document.querySelector('input[name$="[group_url4]"]');
              if (!!target) {
                target.value = data['url4']
              }
            }
            if (!!data['url5']) {
              let target = document.querySelector('input[name$="[group_url5]"]');
              if (!!target) {
                target.value = data['url5']
              }
            }
          }
        }
      };
    })
  }
}

export function getIcondata () {
  let target = document.querySelector('.canpan-icons');

  if (!!target) {
    // URLをPUTで叩く
    let xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open('GET', target.dataset.url)
    xmlHttpRequest.send();

    // レスポンスを受け取る
    xmlHttpRequest.onreadystatechange = function() {
      if (xmlHttpRequest.readyState === 4) {
        if (xmlHttpRequest.status === 200) {
          let data = JSON.parse(xmlHttpRequest.responseText);

          if (!!data['third_party_certificated']) {
            var icons = data['icons'];
            if (!!icons) {
              for (let i = 0; i < icons.length; i++) {
                var icon = icons[i];
                var span = document.createElement('span');
                var img = document.createElement('img');
                img.setAttribute('src', icon['url']);
                img.setAttribute('width', 30);
                img.setAttribute('height', 30);
                img.setAttribute('class', 'mr-2');
                img.setAttribute('title', icon['name']);
                span.setAttribute('class', 'fontsize-90 mb-1');
                span.appendChild(img);
                target.appendChild(span);
              }
            }
          }
        }
      }
    }
  }
}
